<template>
  <div>
    <v-icon
      v-if="!ocultar_btn_ativador"
      :size="15"
      title="Detalhamento das vendas"
      @click="abrirDialog"
    >
      mdi-information-outline
    </v-icon>

    <SysDialogFullScreen v-model="dialog_ativo">
      <template #titulo>
        <div class="d-flex align-center w-full">
          <v-btn icon dark @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div class="ml-5">
            <p class="ma-0 font-19">Detalhamento das Vendas</p>
            <p class="ma-0 mt-n3 font-11">{{ `${produto.idproduto} - ${produto.descricao_produto}` }}</p>
          </div>

          <v-divider vertical dark class="mx-5 my-2" />

          <ConverterEmbalagem dark />

          <v-spacer />

          <ExportarExcel :filtros="filtros"/>
        </div>
      </template>

      <v-tabs color="primary" v-model="tab_selecionado" centered>
        <v-tab
          centered
          v-for="referencia in referencias"
          :key="referencia"
          :href="`#${referencia}`"
          @click="buscarVendasMes(referencia)"
        >
          <span v-text="getDescricaoAnoMes(referencia)" class="font-13" />
        </v-tab>
      </v-tabs>

      <div class="d-flex justify-center mt-5 px-10">
        <SysBotao class="mr-3" @click="ocultar_grafico = !ocultar_grafico">
          <v-icon>{{ ocultar_grafico ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
          Gráfico
        </SysBotao>
        <SysBotao @click="ocultar_tabela = !ocultar_tabela">
          <v-icon>{{ ocultar_tabela ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
          Tabela
        </SysBotao>
      </div>

      <div v-if="ocultar_grafico" class="pt-3 px-10" :style="!ocultar_tabela ? 'height: calc(100vh - 200px)' : 'height: 340px'">
        <GraficoVendasMensal
          ref="graficoVendasMensalRef"
          :data_referencia="tab_selecionado ? `01/${tab_selecionado}` : ''"
          :idgrupo="Number(produto.id_grupo)"
          :idfilial="Number(produto.filial) === 0 ? 9999 : Number(produto.filial)"
          :idproduto="String(produto.idproduto)"
          :produto_eh_combinacao="produto.produto_eh_combinacao"
          :recarregar_dados_count="recarregar_dados_count"
        />
      </div>

      <v-card v-if="ocultar_tabela" class="mx-5 mt-3">
        <ListagemDasVendas
          :produto="produto"
          :headers="headers"
          :items="items"
          :height="!ocultar_grafico ? 'calc(100vh - 300px)' : 'calc(100vh - 630px)'"
          @consumos-desconsiderados="consumosDesconsiderados()"
        />
      </v-card>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import ExportarExcel from './ExportarExcel/Index.vue';
import CompraAPI from "@/api/compra";
import {logout, nomeMeses} from "@/helpers";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import GraficoVendasMensal from "@/components/produto/detalhes/UltimasVendas/GraficoVendasMensal.vue";
import ListagemDasVendas from "@/components/produto/detalhes/UltimasVendas/ListagemDasVendas/Index.vue";
import SysBotao from "@/components/utils/botoes/SysBotao.vue";

export default {
  name: "UltimasVendasProduto",
  components: {
    GraficoVendasMensal,
    ConverterEmbalagem,
    ExportarExcel,
    SysDialogFullScreen,
    SysBotao,
    ListagemDasVendas,
  },
  props: {
    produto: Object,
    ocultar_btn_ativador: Boolean,
    data_inicial: String,
    data_final: String,
    click_bar: Object
  },
  data: () => ({
    dialog_ativo: false,
    tab_selecionado: null,
    headers: [
      { text: "Produto", value: "produto" },
      { text: "Filial", value: "filial" },
      { text: "Pedido", value: "idconsumo" },
      { text: "Emissao", value: "emissao" },
      { text: "Horário", value: "horariomov" },
      { text: "Quantidade", value: "qtde" },
      { text: "Ações", value: "acoes" },
    ],
    items: [],
    referencias: [],
    filtros: {},
    recarregar_dados_count: 0,
    ocultar_grafico: false,
    ocultar_tabela: false,
  }),
  created() {
    this.ocultar_grafico = localStorage.getItem('detalhes_produto_ultimas_vendas_ocultar_grafico') !== 'S';
    this.ocultar_tabela = localStorage.getItem('detalhes_produto_ultimas_vendas_ocultar_tabela') !== 'S';
  },
  methods: {
    abrirDialog() {
      this.dialog_ativo = !this.dialog_ativo;
      this.buscarVendasMes(this.tab_selecionado);
      this.recarregar_dados_count++;
    },
    consumosDesconsiderados() {
      this.buscarVendasMes(this.tab_selecionado);
      this.vendas_selecionadas = [];
      this.recarregar_dados_count++;
      this.$emit('consumos-desconsiderados', {});
    },
    fecharDialog() {
      this.tab_selecionado = this.referencias[this.referencias.length - 1];
      this.pesquisa = '';
      this.dialog_ativo = false;
    },
    buscarVendasMes(ref = null) {
      this.items = [];
      this.vendas_selecionadas = [];

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        produto: this.produto.idproduto,
        produtos: this.produto.produtos,
        grupo: this.produto.id_grupo,
        filialCompra: this.produto.filial <= -1 ? 0 : this.produto.filial,
        referencia: ref,
        data_inicial: this.data_inicial,
        data_final: this.data_final,
      };

      this.filtros = params;

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDetalhesMovimentacaoGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.headers = response.data.colunas_existe;

            this.referencias = response.data.referencias;
            this.items = response.data.vendas.detalhes;

            if (!this.tab_selecionado) {
              this.tab_selecionado = this.referencias[this.referencias.length - 1];
            }
          })
          .catch(logout)
      );
    },
    getDescricaoAnoMes(referencia) {
      const [mes, ano] = referencia.split('/');
      return `${(nomeMeses[mes - 1] || '').substring(0, 3)}/${ano}`;
    },

  },
  watch: {
    ocultar_grafico(value) {
      localStorage.setItem('detalhes_produto_ultimas_vendas_ocultar_grafico', value ? 'N' : 'S');
    },
    ocultar_tabela(value) {
      localStorage.setItem('detalhes_produto_ultimas_vendas_ocultar_tabela', value ? 'N' : 'S');
      this.recarregar_dados_count++;
    },
  }
}
</script>

<style scoped>

</style>
